export const QueryKeyEnum = {
  ANNOUNCEMENTS: {
    MARK_SEEN: 'ANNOUNCEMENTS_MARK_SEEN',
    SEEN: 'ANNOUNCEMENTS_SEEN',
  },
  APP_CONFIG: 'APP_CONFIG',
  AUDIT_LOGS: {
    ALL: 'AUDIT_LOGS_ALL',
  },
  CARS: {
    ALL: 'CARS_ALL',
    DETAILS: 'CAR_DETAILS',
  },
  CHATS: {
    ALL: 'ALL_CHATS',
    ALL_STATUS: 'ALL_STATUS',
    ID: 'CHATS_ID',
    SEND: 'CHATS_SEND',
    SET_READ: 'SET_READ',
  },
  COMMISSION_ADMINISTRATION: 'COMMISSION_ADMINISTRATION',
  COMMISSION_CONFIGURATION: 'COMMISSION_CONFIGURATION',
  COMMISSION_HISTORY: 'COMMISSION_HISTORY',
  COMMISSION_POTENTIAL: 'COMMISSION_POTENTIAL',
  COMPONENT_DEFINITION_DETAILS: 'COMPONENT_DEFINITION_DETAILS',
  COMPONENT_DEFINITIONS: 'COMPONENT_DEFINITIONS',
  COMPONENT_TYPES: 'COMPONENT_TYPES',
  CONTACTS: {
    ALL: 'CONTACTS_ALL',
    CREATE: 'CONTACTS_CREATE',
    DETAILS: 'CONTACT_DETAILS',
    SHORT: 'CONTACTS_SHORT',
    UPDATE: 'CONTACTS_UPDATE',
  },
  CUSTOMERS: {
    ALL: 'CUSTOMERS_ALL',
    APPROVE: 'CUSTOMER_APPROVE',
    CONTACTS: 'CUSTOMERS_CONTACTS',
    CREATE: 'CUSTOMER_CREATE',
    DETAILS: 'CUSTOMER_DETAILS',
    PROSPECTS_COUNT: 'CUSTOMERS_PROSPECTS_COUNT',
    REJECT: 'CUSTOMER_REJECT',
    RESUBMIT: 'CUSTOMER_RESUBMIT',
    TYPE: 'CUSTOMER_TYPE',
    UPDATE: 'CUSTOMER_UPDATE',
  },
  DASHBOARD: {
    EMAILS: 'DASHBOARD_EMAILS',
    TASKS: 'DASHBOARD_TASKS',
  },
  DICTIONARIES: {
    ALL: 'DICTIONARIES_ALL',
    AVAILABILITY: 'DICTIONARY_CALENDAR_AVAILABILITY',
    BY_TYPES: 'DICTIONARIES_BY_TYPES',
    CALENDAR: 'DICTIONARY_CALENDAR',
    CALENDAR_CONFIGURATIONS: 'DICTIONARY_CALENDAR_CONFIGURATIONS',
    DETAILS: 'DICTIONARY_DETAILS',
    SEARCH: 'DICTIONARIES_SEARCH',
  },
  EMAILS: {
    ALL: 'EMAILS_ALL',
    CONTACTS: 'EMAIL_CONTACTS',
    DRAFT: {
      CREATE: 'EMAILS_DRAFT_CREATE',
      SEND: 'EMAILS_DRAFT_SEND',
      UPDATE: 'EMAILS_DRAFT_UPDATE',
    },
    FOLDERS: 'EMAIL_FOLDERS',
    FOLDERS_STATE: 'EMAIL_FOLDERS_STATE',
    READ: 'EMAIL_READ',
    THREAD: 'EMAILS_THREAD',
  },
  EMERGENCY_CONTACTS: {
    ALL: 'EMERGENCY_CONTACTS_ALL',
    CREATE: 'EMERGENCY_CONTACTS_CREATE',
    DETAILS: 'EMERGENCY_CONTACTS_DETAILS',
    UPDATE: 'EMERGENCY_CONTACTS_UPDATE',
  },
  FILES: 'FILES',
  OFFER_DEFINITIONS: {
    COMPONENT_CREATE: 'OFFER_DEFINITIONS_COMPONENT_CREATE',
    COMPONENT_REORDER: 'OFFER_DEFINITIONS_COMPONENT_REORDER',
    COMPONENT_UPDATE: 'OFFER_DEFINITIONS_COMPONENT_UPDATE',
    CREATE: 'OFFER_DEFINITIONS_CREATE',
    DETAILS: 'OFFER_DEFINITIONS_DETAILS',
    SEARCH: 'OFFER_DEFINITIONS_SEARCH',
    UPDATE: 'OFFER_DEFINITIONS_UPDATE',
  },
  OFFER_INSTANCES: {
    ACTIVE_DEFINITIONS: 'OFFER_INSTANCES_ACTIVE_DEFINITIONS',
    ASSIGNEES: 'OFFER_INSTANCES_ASSIGNEES',
    COMPONENT_UPDATE: 'OFFER_INSTANCES_COMPONENT_UPDATE',
    CREATE: 'OFFER_INSTANCES_CREATE',
    DETAILS: 'OFFER_INSTANCES_DETAILS',
    FAILED_WORKFLOW_ACTIONS: 'OFFER_INSTANCES_FAILED_WORKFLOW_ACTIONS',
    ITEM_CREATE: 'OFFER_INSTANCES_ITEM_CREATE',
    ITEM_DELETE: 'OFFER_INSTANCES_ITEM_DELETE',
    ITEM_UPDATE: 'OFFER_INSTANCES_ITEM_UPDATE',
    LIST: 'OFFER_INSTANCES_LIST',
    RETRY_WORKFLOW_ACTION: 'OFFER_INSTANCES_RETRY_WORKFLOW_ACTION',
    STATUS_TRANSITIONS: 'OFFER_INSTANCES_STATUS_TRANSITIONS',
    STATUS_UPDATE: 'OFFER_INSTANCES_STATUS_UPDATE',
    TASKS: 'OFFER_INSTANCES_TASKS',
  },
  OFFER_WORKFLOW: 'OFFER_WORKFLOW',
  PERMISSIONS: {
    CATALOG: 'PERMISSIONS_CATALOG',
  },
  PROCESS: {
    CONTACTS: 'PROCESS_CONTACTS',
    CREATE: 'PROCESS_CREATE',
    CREATE_OFFER_DEFINITIONS: 'PROCESS_CREATE_OFFER_DEFINITIONS',
    CREATION_DEFAULT_DATA: 'PROCESS_CREATION_DEFAULT_DATA',
    CUSTOMER_UPDATE: 'PROCESS_CUSTOMER_UPDATE',
    DETAILS: 'PROCESS_DETAILS',
    EDIT: 'PROCESS_EDIT',
    TODO_INFO: 'PROCESS_TODO_INFO',
    UPDATE_CALENDAR_ENTRY_QUERY: 'PROCESS_UPDATE_CALENDAR_ENTRY_QUERY',
    UPDATE_STATUS: 'PROCESS_UPDATE_STATUS',
  },
  PROCESSES: {
    SEARCH: 'PROCESSES_SEARCH',
  },
  PROCESSES_SHORT: 'PROCESSES_SHORT',
  RECURRING_RESERVATIONS: {
    CANCEL_OCCURRENCE: 'RECURRING_RESERVATIONS_CANCEL_OCCURRENCE',
    CREATE: 'RECURRING_RESERVATIONS_CREATE',
    DELETE: 'RECURRING_RESERVATIONS_DELETE',
    DETAILS: 'RECURRING_RESERVATIONS_DETAILS',
    MOVE_OCCURRENCE: 'RECURRING_RESERVATIONS_MOVE_OCCURRENCE',
    PREVIEW: 'RECURRING_RESERVATIONS_PREVIEW',
    PREVIEW_UPDATE: 'RECURRING_RESERVATIONS_PREVIEW_UPDATE',
    SEARCH: 'RECURRING_RESERVATIONS_SEARCH',
    UPDATE: 'RECURRING_RESERVATIONS_UPDATE',
  },
  REPORTS: {
    DOWNLOAD_CONTACTS: 'REPORTS_DOWNLOAD_CONTACTS',
    STATUS: 'REPORTS_STATUS',
  },
  RESOURCE_TASKS: 'RESOURCE_TASKS',
  ROLES: {
    ALL: 'ROLES_ALL',
    CREATE: 'ROLES_CREATE',
    DELETE: 'ROLES_DELETE',
    DETAILS: 'ROLES_DETAILS',
    UPDATE: 'ROLES_UPDATE',
  },
  SUPERVISORS: {
    ALL: 'SUPERVISORS_ALL',
    CREATE: 'SUPERVISORS_CREATE',
    EMAIL_AVAILABILITY: 'SUPERVISORS_EMAIL_AVAILABILITY',
    UPDATE: 'SUPERVISORS_UPDATE',
  },
  SUPPLIER_DETAILS: 'SUPPLIER_DETAILS',
  TASKS: {
    ALL: 'TASKS_ALL',
    DETAILS: 'TASK_DETAILS',
    MESSAGE_ADD: 'TASK_MESSAGE_ADD',
  },
  USERS: {
    ALL: 'USERS_ALL',
    ASSIGN_ROLE: 'USERS_ASSIGN_ROLE',
    CREATE: 'USERS_CREATE',
    CURRENT: 'USER_CURRENT',
    CURRENT_RELOAD: 'USER_CURRENT_RELOAD',
    PERMISSION_GRANTS: 'USERS_PERMISSION_GRANTS',
    REPLACE_PERMISSION_GRANTS: 'USERS_REPLACE_PERMISSION_GRANTS',
    SHORT: 'USERS_SHORT',
    UPDATE: 'USERS_UPDATE',
  },
} as const;
